import gql from 'graphql-tag';

export const getRoleAssignmentsQuery = gql`
  query getRoleAssignments($resourceId: String!) {
    getRoleAssignments(resourceId: $resourceId) {
      user {
        userId
        firstName
        lastName
        imageUrl
        email
      }
      team {
        teamId
        name
        imageUrl
        members {
          teamMembershipId
        }
      }
      organisation {
        organisationId
      }
      role {
        roleId
        name
      }
      canSearch
      public
      isPrivate
      password
      resourceRoleAssignmentId
      resourceType
    }
  }
`;

const getRoleAssignments = () => ({
  query: getRoleAssignmentsQuery,
  ignoreCache: true,
  module: 'users',
  buildVariables: (resourceId) => ({ resourceId })
});

export default getRoleAssignments;